import { ConnectedHistoricalChart, Resolutions } from '@innovyze/summaryze';
import { getSensorDataOverride } from '@Selectors/sensorGroup.selector';
import { EditSensorDataSort, SensorDataPoint } from '@Types';
import filterDuplicateSensorDataPoints, {
	convertToPoint,
} from '@Utils/filterDuplicateSensorDataPoints';
import { FormikProps } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import editSensorDataSort from './utils/editSensorDataSort';

const DataChartContainer = styled.div`
	grid-row: 1/3;
	height: 600px;
`;

interface EditSensorDataChartProps {
	formRef: React.MutableRefObject<
		| FormikProps<{
				points: SensorDataPoint[];
				sort: EditSensorDataSort;
		  }>
		| undefined
	>;
}

function EditSensorDataChart({ formRef }: EditSensorDataChartProps) {
	const sensorDataOverride = useSelector(getSensorDataOverride);
	const { sensorId } = useParams<{ sensorId: string }>();
	const formikProps = formRef.current;

	return (
		<DataChartContainer>
			<ConnectedHistoricalChart
				primarySeries={{
					alias: sensorId,
					id: sensorId,
					displayOptions: { chartType: 'line' },
					func: 'Close',
					resolution: Resolutions.Raw,
					unit: '',
					dataOverride: sensorDataOverride,
				}}
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore-next-line
				options={{
					plotOptions: {
						dataGrouping: {
							enabled: false,
						},
					},
				}}
				displayOptions={{ showXGrid: true, showYGrid: true }}
				// @ts-ignore
				onClickPoint={point => {
					const { x: timestampInSeconds, y: value } = point;
					if (formikProps?.setValues) {
						const pointObjectObject = convertToPoint(
							timestampInSeconds,
							value as number,
						);
						formikProps?.setValues(oldValues => {
							const sortedPoints = editSensorDataSort(
								filterDuplicateSensorDataPoints([
									...oldValues.points,
									pointObjectObject,
								]),
								oldValues.sort,
							);
							return { ...oldValues, points: sortedPoints };
						});
					}
				}}
			/>
		</DataChartContainer>
	);
}

export default React.memo(
	EditSensorDataChart,
	(prev, current) => prev.formRef === current.formRef,
);
